import { FC } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { MaskedInput } from 'shared/components/MaskedInput';
import { useDebouncedCallback, useFilterChangeCallback } from 'shared/hooks';
import { selectOfferIdFilter } from 'shared/selectors/advancedFilters';

export const OfferIdContainer: FC = () => {
  const { label, value } = useSelector(selectOfferIdFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useDebouncedCallback(
    (offerId: string) => {
      onChange({ action: 'setOfferId', arguments: [offerId ? Number(offerId) : null] });
    },
    300,
    [],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MaskedInput min={1} width={260} value={value} mask={Number} onAccept={handleChange} />
    </AdvancedFilterRow>
  );
};
